<template>
  <v-menu open-on-hover right content-class="volume-content" :close-on-content-click="false"  attach="#mediaVolume">
      <template v-slot:activator="{ on }">
          <v-btn id="mediaVolume" class="media-control-button hoverable media-volume"  @click.stop.prevent="" v-on="on">
              <v-icon>{{localIcons['mdi-volume-high']}}</v-icon>
        </v-btn>
      </template>

    <v-slider
    style="z-index:3"
          ref="volumeslider"
          v-model="volume"
          :value="0.5"
          class="volume-slider custom-slider"
          :max="1"
          :min="0"
          :step="0.01"
          color="#20f7c4"
          height="auto"
          @click.stop.prevent=""
          @mousedown.stop.prevent=""
        ></v-slider>

    </v-menu>
</template>

<script>
import { mdiVolumeHigh} from '@mdi/js'
export default {
  props: ['defaultVolume'],
  components: {
  },
  data () {
    return {
      volume: 0,
      localIcons:{
        'mdi-volume-high':mdiVolumeHigh
      }
    }
  },
  name: 'volume-button',
  watch: {
    volume (newVal) {
      this.$emit('change', newVal)
    }
  },
  mounted () {
    this.volume = this.defaultVolume
  }
}
</script>

<style>
.volume-content{
  width: 245px;
  min-width: 245px!important;
  background: transparent;
  border-radius: 0px;
  box-shadow: none;
    overflow: hidden;
  -webkit-box-shadow: none;
  left:40px!important;
}

.volume-content .v-slider--horizontal{
 min-height:28px!important;
}
.volume-content .row{
  margin:0px;
}

.volume-content .col{
  padding:0px;
}

.volume-content .col .row{
  height:33%;
  font-size: 12px;
  color:#0062ff;
  user-select: none;
}
.volume-content .top{
  align-items:flex-start;
}
.volume-content .mid{
  padding-top:30px;
  align-items:center;
}
.volume-content .bottom{
  align-items:flex-end;
}
.media-control-button.media-volume{
  z-index:3;
}
.volume-content .v-input__slot{
  background: black;
}
</style>
